import { render, staticRenderFns } from "./TableFixedHeader.vue?vue&type=template&id=112f3b4a"
import script from "./TableFixedHeader.vue?vue&type=script&lang=js"
export * from "./TableFixedHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports